module.exports = __webpack_public_path__ + "img/blog5.ea652077.jpg";